import React, { useContext } from "react";
import "../deliveryInfoModal.scss";
import { Avatar, Button, Link } from "@mui/material";
import StateContext from "../../../StateContext";
import { useTranslation } from "react-i18next";
import vendorsConfig from "../../../vendorsConfig";

function Wiyak({ props, loading }) {
  const { t } = useTranslation();
  const { invoiceable, open, setOpen } = props;
  const appState = useContext(StateContext);
  const { deliveryRiderInfo } = appState;
  const {
    riderName,
    riderNumber,
    bookingId,
    vehicleNumber,
    vehicleColor,
    vehicleBrand,
  } = deliveryRiderInfo;

  return (
    <div
      className={`${appState.langValue === "ar" ? "directionRtl" : ""}`}
      id="reviewModalMainl1"
    >
      <div className="px-1">
        <div className="container-fluid mt-2">
          <div className="row d-flex justify-content-center">
            <div className="col-md-2 col-6 px-0 d-flex justify-content-center  align-items-center">
              <Avatar
                src={`https://qs.${vendorsConfig.SLUG}.dev/assets/images/wyak.png`}
                sx={{ width: 100, height: 100 }}
              />
            </div>
          </div>
        </div>
        <div className="container-fluid px-0">
          <h3
            className={`familyManrope800 mt-2 ${
              appState.langValue === "ar" ? "text-center" : "text-center"
            }`}
          >
            {riderName || `Rider Name is Not Avalaible`}
          </h3>
          <div className="row mt-2">
            <div className="col-12 d-flex justify-content-center ">
              {riderNumber || `Phone nunber is Not Avalaible`}
            </div>
            <div className="col-12 d-flex align-items-center justify-content-center"></div>
          </div>
          <div className="trackOrder d-flex align-items-center justify-content-center  py-md-2">
            <h3
              className={`familyManrope800 textBlack pt-md-2 pb-1 ${
                appState.langValue === "ar" ? "text-right" : "text-left"
              }`}
            >
              <strong>Booking_id:</strong> {bookingId}
            </h3>
          </div>

    <hr />
    <div className="trackOrder d-flex align-items-center justify-content-center flex-column   py-md-2">
            <h3
              className={`familyManrope800 textBlack pt-md-2 pb-1 ${
                appState.langValue === "ar" ? "text-right" : "text-left"
              }`}
            >
              
              <strong>Vehicle Brand:</strong> {vehicleBrand}
             </h3>
            <h3
              className={`familyManrope800 textBlack pt-md-2 pb-1 ${
                appState.langValue === "ar" ? "text-right" : "text-left"
              }`}
            >
              
              <strong>Vehicle Color:</strong> {vehicleColor}
              </h3>
            <h3
              className={`familyManrope800 textBlack pt-md-2 pb-1 ${
                appState.langValue === "ar" ? "text-right" : "text-left"
              }`}
            >
          
              <strong>Vehicle Number:</strong> <span style={{color:'red'}}>{vehicleNumber}</span>            </h3>
          </div>

          <div className="row mx-0 d-flex justify-content-center pb-1 pt-2 submitBtn">
            <Button
              className=" col-12 blackBtn py-3 text-capitalized"
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              {t("invoice.Close")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wiyak;
